<template>
<div>
  <template v-if="!loading">
    <template v-if="showPolicyInfo">
      <component :is="currentPolicyView" :policy="policy" />
    </template>
    <template v-else>
      <router-view />
    </template>
  </template>

  <v-dialog v-model="loading" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        Loading policy information...
        <v-progress-linear indeterminate color="white" class="mb-0" />
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<style>
</style>

<script>
import { mapState, mapActions } from 'vuex';
import apiService from '@/services/shared/agentPortalApiService.js';
import PolicyViewTabs from '@/views/clientViewer/Policy/PolicyViewTabs.vue';

export default {
  components: {
    PolicyViewTabs
  },
  data: function () {
    return {
      policy: null,
      loading: true,
      showPolicyInfo: true,
      policyRouteNames: [
        'clientPolicyDetail'
      ]
    };
  },
  computed: {
    ...mapState(['client']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    currentPolicyView: function () {
      return 'PolicyViewTabs';
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    policyTitle: function () {
      if ((this.policy || null) === null) {
        return '';
      }
      return `${this.policy.displayOrder + 1}-${this.policy.title}`;
    }
  },
  watch: {
    policyOrderNumber: async function () {
      // Client id has changed? Go fetch more policies
      await this.getPolicyDetails();
    },
    $route: {
      handler (to, from) {
        this.showPolicyInfo = this.policyRouteNames.indexOf(to.name) >= 0;
      },
      deep: true
    }
  },
  created: async function () {
    this.showPolicyInfo = this.policyRouteNames.indexOf(this.$route.name) >= 0;
    await this.getPolicyDetails();
  },
  destroyed: function () {
    this.setPolicyTitle(null);
    this.setSelectedLineOfBusinessCode(null);
  },
  methods: {
    ...mapActions(['setError', 'setActivePolicyTab', 'setPolicyTitle', 'setPolicyType', 'setSelectedLineOfBusinessCode']),
    getPolicyDetails: async function () {
      this.loading = true;

      var rs = await apiService.getGeneralPolicyInformation(this.clientId, this.policyOrderNumber);
      if (rs.code === 2) {
        this.setError('No policy information found.');
      } else if (rs.code === 0) {
        if ((rs.data || null) !== null && rs.data.length > 0) {
          this.policy = rs.data[0];
          this.setPolicyTitle(this.policyTitle);

          if ((this.policy.linesOfBusiness || null) !== null) {
            if (this.policy.linesOfBusiness.length === 1) {
              this.setSelectedLineOfBusinessCode(this.policy.linesOfBusiness[0].code);
            }
          }
        } else {
          this.setError('No policy information found.');
        }
      } else {
        this.setError(rs.message);
      }

      this.loading = false;
    }
  }
};
</script>
